export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div className="flex flex-wrap items-start sm:items-end justify-between gap-3 sm:gap-4 mb-6 sm:mb-8 pb-4 sm:pb-5 border-b border-border"
         data-testid={testId}>
      <div className="min-w-0 max-w-full">
        {eyebrow && <p className="label-tiny mb-1.5 sm:mb-2">{eyebrow}</p>}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-display font-bold tracking-tight text-foreground break-words">
          {title}
        </h1>
        {description && (
          <p className="mt-1.5 sm:mt-2 text-sm text-muted-foreground max-w-2xl">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
          {actions}
        </div>
      )}
    </div>
  );
}
